import React, { useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Dropdown,
  Menu,
  Popconfirm,
  Table,
  Modal,
  Select,
  Input,
  Tag,
} from 'antd';

import {
  EditOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DownOutlined,
  PlusOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as axios from 'axios';
import CustomContent from '../../../components/Content/CustomContent';
import {
  deletePoisAction,
  getPoisAction,
} from '../../../actions/AppCms/PoiActions';
import { history } from '../../../utils/history';
import { host } from '../../../utils/config';
import Authorized from '../../../components/Authorization/Authorized';
import {
  resetPoiFilters,
  updatePoiFilters,
} from '../../../actions/FilterActions';
import WrappedPOIListDrawer from './POIListDrawer';
import { poisPaginationParams } from './Constants';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';

const { Option } = Select;
const { Search } = Input;

const PoiList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [action, setAction] = useState({});
  const [language, setLanguage] = useState('');
  const [defaultLanguage, setDefaultLanguage] = useState('');

  const { pois, poiFilterParams, isPoiFiltered, cmsLanguageList } = useSelector(
    store => ({
      pois: store.poiReducer.pois,
      poiFilterParams: store.filterReducer.poiFilterParams,
      isPoiFiltered: store.filterReducer.isPoiFiltered,
      cmsLanguageList: store.cmsLanguageReducer.cmsLanguageList,
    }),
  );

  useEffect(() => {
    // dispatch(getPoisAction(poiFilterParams));
    dispatch(getCmsLanguagesAction());
  }, []);

  const handleFilterParams = filter => {
    const newParams = {
      ...poiFilterParams,
      ...filter,
      page: 0,
    };
    dispatch(updatePoiFilters(newParams));
    dispatch(getPoisAction(newParams));
  };

  useEffect(() => {
    cmsLanguageList.map(item => {
      if (item.defaultInMobileApp) {
        setLanguage(item.isoLanguage.code);
        setDefaultLanguage(item.isoLanguage.code);
        handleFilterParams({ ...poiFilterParams, language: defaultLanguage });
      }
      return null;
    });
  }, [cmsLanguageList]);

  const onCloseDrawer = () => {
    setDrawerVisible(false);
  };

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const handleResetFilters = () => {
    dispatch(resetPoiFilters());
    setTimeout(() => {
      dispatch(getPoisAction({ ...poisPaginationParams }));
    }, 100);
  };

  const handleSearch = value => {
    handleFilterParams({
      title: value,
      page: 0,
    });
  };

  const handleDownload = () => {
    const bearer = localStorage.getItem('userToken');

    let options = {
      url: host + '/api/point-of-interests/export',
      method: 'GET',
      responseType: 'blob', // important
      headers: { Authorization: bearer },
    };
    if (action.key === '1') {
      options = {
        ...options,
        params: {
          all: true,
          language,
        },
      };
    } else if (action.key === '2') {
      options = {
        ...options,
        params: {
          idList: selectedRowKeys.join(','),
          all: false,
          language,
        },
      };
    }
    axios(options).then(response => {

      const today = new Date();
      const currentDate =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'poi-reports-' + currentDate + '.csv');
      document.body.appendChild(link);
      link.click();
    });
  };

  const showModal = value => {
    setAction(value);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    handleDownload();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleTableChange = pagination => {


    if (poiFilterParams.size !== pagination.pageSize) {

      const newParams = {
        ...poiFilterParams,
        size: pagination.pageSize,
        page: 0,
      };
      dispatch(updatePoiFilters(newParams));
      dispatch(getPoisAction(newParams));
      return;
    }
    if (poiFilterParams.page !== pagination.current - 1) {

      const newParams = {
        ...poiFilterParams,
        page: pagination.current - 1,
      };
      dispatch(updatePoiFilters(newParams));
      dispatch(getPoisAction(newParams));
    } else {

    }
  };

  const handleAddNew = () => {
    history.push('/add-poi');
  };

  const handleMultipleDelete = () => {
    dispatch(deletePoisAction(selectedRowKeys.join(','))).then(() => {
      setSelectedRowKeys([]);
    });
  };

  const handleSingleDelete = () => {
    dispatch(deletePoisAction(selectedItem.id)).then(() => {
      setSelectedRowKeys([]);
    });
  };

  const handleMenuClick = value => {
    if (value.key === 'edit') {
      const updatePath = '/updatePoi/' + selectedItem.id;

      history.push(updatePath);
    }
    // if (value.key === 'delete') {
    //   handleSingleDelete();
    // }
  };

  function handleLanguageChange(value) {
    setLanguage(value);

  }

  const onSelectChange = selected => {

    setSelectedRowKeys(selected);
  };

  const hasSelected = selectedRowKeys.length > 0;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const menu = (
    <Authorized asset="appcms" operation="write">
      <Menu onClick={handleMenuClick}>
        <Menu.Item key="edit">
          <EditOutlined />
          {t('common.update')}
        </Menu.Item>
        <Menu.Item key="delete">
          <Popconfirm
            title={t('common.sureToDelete')}
            placement="left"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => handleSingleDelete()}
          >
            <DeleteOutlined />
            {t('common.delete')}
          </Popconfirm>
        </Menu.Item>
      </Menu>
    </Authorized>
  );

  const exportMenu = (
    <Menu onClick={showModal}>
      <Menu.Item key="1">
        <DownloadOutlined />
        {t('appCms.poi.allPois')}
      </Menu.Item>
      <Menu.Item key="2" disabled={!hasSelected}>
        <DownloadOutlined />
        {t('appCms.poi.selectedPois')}
      </Menu.Item>
    </Menu>
  );
  const columns = [
    {
      title: t('common.title'),
      dataIndex: ['data', 'content'],
      key: 'title',
      render: (text, record) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        (<a
          onClick={() => {
            history.push('/updatePoi/' + record.id);
          }}
        >
          <span>{text && text[0].title}</span>
        </a>)
      ),
    },

    {
      title: t('appCms.poi.subtitle'),
      dataIndex: ['data', 'content'],
      key: 'subtitle',
      render: text => <span>{text && text[0].subtitle}</span>,
    },
    {
      title: t('appCms.poi.externalReference'),
      dataIndex: ['data', 'externalReference'],
      key: 'externalReference',
    },
    {
      title: t('appCms.poi.poiGroup'),
      dataIndex: ['data', 'group'],
      key: 'group',
      render: text => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        (<a
          onClick={() => {
            history.push('/updatePoiGroup/' + text.id);
          }}
        >
          <span>{text && text.title}</span>
        </a>)
      ),
    },
    {
      title: t('appCms.poi.beaconDetectionRange'),
      dataIndex: ['data', 'beaconSensitivityRange'],
      key: 'beaconSensitivityRange',
      render: text => (
        <span>
          <Tag
            style={{
              // color: '#7ed321',
              // borderColor: '#7ed321',
              color: '#ff4d4f',
              borderColor: '#ff4d4f',
            }}
          >
            {text && text.min}dBm
          </Tag>
          -
          <Tag
            style={{
              marginLeft: '6px',
              color: '#7ed321',
              borderColor: '#7ed321',
            }}
          >
            {text && text.max}dBm
          </Tag>
        </span>
      ),
    },
    {
      title: t('appCms.poi.beacon'),
      dataIndex: ['data', 'beaconId'],
      key: 'beaconId',
    },
    {
      title: t('common.actions'),
      key: 'action',
      render: () => (
        <span>
          <Dropdown overlay={menu} trigger={['click']}>
            <a className="ant-dropdown-link" href="#">
              {t('common.actions')} <DownOutlined />
            </a>
          </Dropdown>
        </span>
      ),
    },
  ];

  return (
    (<CustomContent>
      <Search
        placeholder={t('common.search')}
        onSearch={value => handleSearch(value)}
        allowClear
        style={{ float: 'left', width: 300 }}
        defaultValue={poiFilterParams.search}
      />
      <Button
        // danger={true}
        type={isPoiFiltered ? 'danger' : 'default'}
        ghost={isPoiFiltered}
        icon={<FilterOutlined />}
        onClick={showDrawer}
        style={{ marginLeft: 12 }}
      >
        {t('appCms.poi.filters')}
      </Button>
      <Authorized asset="appcms" operation="write">
        <Button
          icon={<PlusOutlined />}
          type="primary"
          style={{ float: 'right', marginBottom: 16 }}
          onClick={handleAddNew}
        >
          {t('common.add')}
        </Button>
        <Popconfirm
          title={t('common.sureToDelete')}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => handleMultipleDelete()}
        >
          <Button
            icon={<DeleteOutlined />}
            disabled={!hasSelected}
            style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
          >
            {t('common.delete')}
          </Button>
        </Popconfirm>
      </Authorized>
      <Dropdown overlay={exportMenu}>
        <Button
          icon={<DownloadOutlined />}
          style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
        >
          {t('appCms.export')}
        </Button>
      </Dropdown>
      <Divider />
      <Table
        columns={columns}
        dataSource={pois.content}
        rowSelection={rowSelection}
        pagination={{
          defaultPageSize: poiFilterParams.size,
          current: poiFilterParams.page + 1,
          total: pois.totalElements,
          showTotal: (total, range) => {
            return t('common.paginationTotal', { start: range[0], end: range[1], total });
          },

          showSizeChanger: true,
          pageSizeOptions: [
            '10',
            '20',
            '30',
            '40',
            '50',
            '100',
            '200',
            '500',
            '1000',
          ],
        }}
        expandable={{
          expandedRowRender: record => (
            <p> {record.data.content[0].description} </p>
          ),
          rowExpandable: record =>
            record.data.content[0].description !== undefined,
        }}
        onChange={handleTableChange}
        rowKey={record => record.id}
        onRow={record => {
          return {
            onClick: () => setSelectedItem(record),
          };
        }}
      />
      <WrappedPOIListDrawer
        visible={drawerVisible}
        parentOnClose={onCloseDrawer}
        handleFilterParams={handleFilterParams}
        filterParams={poiFilterParams}
        handleResetFilters={handleResetFilters}
        defaultLanguage={defaultLanguage}
      />
      <Modal
        title={t('appCms.language')}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={t('common.ok')}         
        cancelText={t('common.cancel')} 
      >
        <p>{t('appCms.selectExportLanguage')}</p>
        <Select
          defaultValue={language}
          style={{ width: 220 }}
          onChange={handleLanguageChange}
        >
          {cmsLanguageList.map(item => (
            <Option key={item.id} value={item.isoLanguage.code}>
              {item.isoLanguage.title}
            </Option>
          ))}
        </Select>
      </Modal>
    </CustomContent>)
  );
};

export default PoiList;
